export default {"src":"/_next/static/media/infoError.acaebfaa.svg","height":12,"width":11,"blurWidth":0,"blurHeight":0};